export default __webpack_public_path__ + "static/media/Montserrat-Regular.ac98a5f5.ttf";